import { DeleteOutlined, FileOutlined } from "@ant-design/icons";
import { Col, Row, Tooltip, Typography } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { FC } from "react";

interface FeedbackUploaderProps{
    fileList:any[]
    setFileList:any
}
const FeedbackUploader:FC<FeedbackUploaderProps> = ({fileList,setFileList}) => {
    const { Text } = Typography;

  const beforeUpload = (file: any) => {
    
    setFileList([file]);
  
  };
    return ( <Row gutter={[0,10]}>
     <Col xs={24}>
                <Dragger
                  accept=".png,.jpeg,.jpg,.webp,.gif"
                  beforeUpload={beforeUpload}
                  customRequest={() => {}}
                  multiple={true}
                  fileList={fileList}
                  showUploadList={false}
                  className="!w-full"
                >
                 

                  <div className="!flex justify-center">
                    <Text className="ml-2 !mt-2 !text-xs !text-indigo-500">Yükle</Text>
                  </div>
                  <div className="ant-upload-hint">
                    <Text className="!text-xs !text-[#606060]" >
                    Gerekli evrakları buradan yükleyebilirsiniz.
                    </Text>
                  </div>
                  
                </Dragger>
              </Col>
              <Col xs={24}>
                  {fileList.map((item) => {
                    return (
                      <>
                        <div className="!flex justify-between">
                          <div className="!flex items-center gap-1">
                            <FileOutlined className="!text-indigo-500" />
                            {
                                item.name.length<=30?<>
                                
                                <Text className="!text-xs" >{item.name}</Text>
                                </>:<>
                                <Tooltip title={item.name} >
                                <Text className="!text-xs" >{item.name.slice(0,30)}</Text>
                                </Tooltip>
                                
                                </>
                            }
                          </div>
                          <div>
                            <DeleteOutlined
                              className="!text-red-600"
                              onClick={() => {
                                setFileList([]);
                              }}
                            />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </Col>
    </Row> );
}
 
export default FeedbackUploader;